<template>
    <div class="position-fixed" style="width: 100%;">
        <BHeader :title="$t('usracc.language_edit')" :isLogin="true" back="/usracc" :isInUserAccount="true"/>

        <div class="language">
            <BButtonGroup>
                <div class="wrapper" style="margin-right:16px" @click="whichButton='Japanese'">
                    <BButton class="first-button" :class="whichButton=='Japanese' ? 'onClick':''" >
                        日本語
                    </BButton>
                    <BImg :src="whichButton=='Japanese' ? selectActive : select" class="select"></BImg>
                </div>
                <div class="wrapper" @click="whichButton='English'">
                    <BButton class="middle-button" :class="whichButton == 'English' ? 'onClick':''" >
                        English
                    </BButton>
                    <BImg :src="whichButton=='English' ? selectActive : select" class="select"></BImg>
                </div>
            </BButtonGroup>

            <BButton @click="isShow = true" style="box-shadow:none">{{$t("common.update")}}</BButton>
        </div>


        <BFooter whichPage="1" />
        <BOverlay :show="isShow" z-index=1031 no-wrap fixed opacity=0 >
            <template #overlay>
                <BCard no-body align="center" class="notice-card">
                    <div class="imgInlie">
                        <BImg :src="warning_src" style="2px;"></BImg>
                    </div>
                    <div v-dompurify-html='$t("message.update")'></div>
                    <div class="inner-button-wrapper">
                        <div class="button-item-small">
                            <BButton @click="isShow = false">{{$t("common.cancel")}}</BButton>
                        </div>
                        <div class="button-item">
                            <BButton @click="whichButton=='Japanese' ? selectJa() : selectEn();isShow = false">OK</BButton>
                        </div>
                    </div>
			    </BCard>
            </template>
        </BOverlay>
    </div>

</template>

<script>
import BHeader from '@/views/header.vue'
import BFooter from '@/views/footer.vue'
import { ref, onBeforeMount } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
    name:'language',
    components : {
        BHeader,
        BFooter,
    },
    setup () {
        const warning_src = require('@/assets/icon/notice_warning.svg')
        const selectActive = require('@/assets/icon/selectActive.svg')
        const select = require('@/assets/icon/select.svg')
        const whichButton = ref()
        const isShow = ref(false)
        onBeforeMount(()=>{
            if(localStorage.getItem("language") == 'en'){
                whichButton.value = 'English'
            }else{
                whichButton.value = 'Japanese'
            }
        })
        const { locale } = useI18n({ useScope: 'global' })
        function selectJa() {
            locale.value = 'ja'
            localStorage.setItem('language','ja')
        }

        function selectEn() {
            locale.value = 'en'
            localStorage.setItem('language','en')
        }

        return {
            isShow,
            warning_src,
            select,
            selectActive,
            whichButton,
            selectJa,
            selectEn,
        }
    }
}
</script>

<style lang="scss" scoped>
    .language{
        margin-top: 57px;
        padding: 0px 16px;
        .btn-group{
            height: 40px;
            width: 100%;
            margin-bottom: 24px;
            .onClick{
                border: 1px #12C891 solid !important;
            }
            .btn{
                flex:1;
                width: 100%;
                padding: 6px 17px;
                border-radius: 4px;
                border: 1px #CCCCCC solid;
                background: white;

                font-family: 'Hiragino Kaku Gothic ProN';
                font-style: normal;
                font-weight: 300;
                font-size: 16px;
                line-height: 21px;
                color: #30353B;
                .bg-secondary{
                    background: #EE4967!important;
                }
            }
            .btn:hover{
                box-shadow: none!important;
            }
            .btn:focus {
                box-shadow: none!important;
            }
            .wrapper{
                position: relative;
                width: 100%;
                img, svg{
                    width: 20px;
                    height: 20px;
                    position: absolute;
                    top: 10px;
                    left: 8px;
                    margin-right: 4px;
                }
            }
        }
        
        .btn{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 8px 16px;
            gap: 4px;
            width: 100%;
            height: 40px;
            background: #2394F7;
            border-radius: 4px;
            border-width: 0px;
            flex: none;
            order: 0;
            align-self: stretch;
            flex-grow: 1;
            font-family: 'Hiragino Kaku Gothic ProN';
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 18px;
            color: #FFFFFF;
        }
    }
    .b-overlay{
          background: rgba(0, 0, 0, 0.6);
      }
    .notice-card{
        width: 300px;
        word-break: keep-all;
        background: #FFFFFF;
        border-radius: 4px;
        border: none;
        padding: 16px;
        gap: 16px;
        display: flex;
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
        color: #30353B;
        .inner-button-wrapper{
            margin-bottom: 0px;
            margin-top: 8px;
            display:flex;
            flex-direction: row;
            gap: 8px;
            .button-item{
                flex: 1;
                display: flex;
                .btn{
                    width: max-content;
                    flex: 1;
                    padding: 7px 8px;
                    background: #2394F7;
                    border-radius: 4px;
                    font-weight: 600;
                    font-size: 13px;
                    line-height: 18px;
                    color: #FFFFFF;
                    border: none;
                }
                .btn:hover{
                    box-shadow: none!important;
                }
            }
            .button-item-small{
                flex: 0.5;
                display: flex;
                .btn{
                    width: max-content;
                    flex: 1;
                    padding: 7px 8px;
                    background: #A8B0BB;
                    border-radius: 4px;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    border: none;
                    border-radius: 4px;
                    font-weight: 600;
                    font-size: 13px;
                    line-height: 18px;
                    color: #FFFFFF;
                }
                .btn:hover{
                    box-shadow: none!important;
                }
            }
        }
    }   
</style>